var map = {
	"./asos-world.svg": 19971,
	"./errorEmoji.svg": 48730,
	"./filter.svg": 57072,
	"./heart.svg": 19262,
	"./iconClose.svg": 79187,
	"./iconCloseVariant.svg": 68278,
	"./iconDownCaret.svg": 43282,
	"./iconLeftCaret.svg": 8143,
	"./iconRightCaret.svg": 53130,
	"./iconRightChevron.svg": 93222,
	"./leftArrow.svg": 5768,
	"./newTab.svg": 37325,
	"./notification.svg": 29335,
	"./pause.svg": 58208,
	"./play.svg": 51272,
	"./promo.svg": 86567,
	"./search.svg": 73938,
	"./snowflake.svg": 47314,
	"./sort.svg": 60434,
	"./swipe.svg": 33796,
	"./tick.svg": 57441,
	"./tickVariant.svg": 21844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35375;